/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientEMSUserTypename = "PatientEMSUser" as const;

/**
 *
 * @export
 * @interface PatientEMSUser
 */
export interface PatientEMSUser {
  /**
   *
   * @type {Date}
   * @memberof PatientEMSUser
   */
  dateOfBirth: string;
  /**
   *
   * @type {string}
   * @memberof PatientEMSUser
   */
  id: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientEMSUser
   */
  readonly __typename?: string;
}

export function PatientEMSUserFromJSON(json: any): PatientEMSUser {
  return PatientEMSUserFromJSONTyped(json, false);
}

export function PatientEMSUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientEMSUser {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientEMSUserTypename,

    dateOfBirth: json["date_of_birth"],
    id: json["id"],
  };
}

export function PatientEMSUserToJSON(object?: PatientEMSUser | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: tzDate(value.dateOfBirth).format(),
    id: value.id,
  };
}
